import React, { useState } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import { actions } from '+/nav/navSlice';
import { actions as authActions } from '@/auth/sagaSlice';
import { checkPermissions } from '#/permissions';
import history from '#/history';


const drawerWidth = 220;

const useStyles = makeStyles(theme => ({
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    hide: {
        display: 'none'
    },
    title: {
        flexGrow: 1,
        textAlign: 'center'
    },
    icon: {
        color: '#fff'
    }
}));

const TopNav = props => {

    const {
        toggleSidebar, open, role, logout
    } = props;

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const isLegal = checkPermissions(['legal', 'legal_admin'], role);

    const menuOpen = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = route => {

        handleClose();
        history.push(route);
    };

    return (
        <AppBar
            color='primary'
            position='fixed'
            className={clsx(classes.appBar, {
                [classes.appBarShift]: open
            })}
        >
            <Toolbar>
                <IconButton
                    color='inherit'
                    aria-label='open drawer'
                    onClick={toggleSidebar}
                    edge='start'
                    className={clsx(classes.menuButton, open && classes.hide)}
                >
                    <MenuIcon />
                </IconButton>
                <Typography className={classes.title} variant='h6' noWrap>
                        United Property Management
                </Typography>

                <IconButton
                    aria-label='more'
                    aria-controls='long-menu'
                    aria-haspopup='true'
                    onClick={handleClick}
                >
                    <MenuOpenIcon className={classes.icon} />
                </IconButton>
                <Menu
                    id='long-menu'
                    anchorEl={anchorEl}
                    keepMounted
                    open={menuOpen}
                    onClose={handleClose}
                >

                    {isLegal && (
                        <MenuItem onClick={() => handleMenuItemClick('/user/signature')}>
                            Add Signature
                        </MenuItem>
                    )}

                    <MenuItem onClick={() => handleMenuItemClick('/password/update')}>
                        Change Password
                    </MenuItem>

                    <MenuItem onClick={logout}>
                        Log Out
                    </MenuItem>

                </Menu>
            </Toolbar>

        </AppBar>
    );
};

const mapStateToProps = state => ({
    role: state.auth.role,
    permissions: state.auth.permissions,
    open: state.sidebar.visible,
    menuItemIndex: state.sidebar.menuItemIndex
});


export default connect(mapStateToProps, {
    ...actions,
    ...authActions
})(TopNav);
